import { colors } from '@aloft/toolkit-sui';
import { Card, CardProps } from '@aloft/toolkit-sui/chakra';

import { forwardRef } from 'react';

export const ListCard = forwardRef<HTMLDivElement, CardProps>((props, ref) => {
  return (
    <Card
      ref={ref}
      background={colors.surface1}
      px={6}
      py={4}
      _hover={{ bg: 'hover1' }}
      cursor="pointer"
      {...props}
    ></Card>
  );
});
